<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門門店</div>
            <div class="breadcrumb-item">已簽收-備註</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>客戶名稱</span>
                                        </div>
										<span>{{form.recipient_contacts}}</span>
                                    </FormItem>
                                </Col>
                            </Row>
							
							<Row :gutter="15">
							    <Col span="14">
							        <FormItem>
							            <div slot="label" class="form-label">
							                <span>客戶電話</span>
							            </div>
							            <span>{{form.recipient_phone}}</span>
							        </FormItem>
							    </Col>
							</Row>
							
							<Row :gutter="15">
							    <Col span="14">
							        <FormItem>
							            <div slot="label" class="form-label">
							                <span>快遞單號</span>
							            </div>
										<span>{{form.odd_numbers}}</span>
							        </FormItem>
							    </Col>
							</Row>
							
							<Row :gutter="15">
							    <Col span="14">
							        <FormItem>
							            <div slot="label" class="form-label">
							                <span>袋號</span>
							            </div>
										<span>{{form.sack_number}}</span>
							        </FormItem>
							    </Col>
							</Row>
							
							<Row :gutter="15">
							    <Col span="14">
							        <FormItem>
							            <div slot="label" class="form-label">
											<em class="red">* </em>
							                <span>備註</span>
							            </div>
                                        <span>{{form.remarks_show}}</span>
										<Input type="textarea" v-model="form.remarks"></Input>
							        </FormItem>
							    </Col>
							</Row>
							
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">修改</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                pickAddress: [],    //提貨櫃點
                detail: {},
                isSubmiting: false,
                form: {
					id: '',
                    recipient_phone: '',
					recipient_contacts: '',
					odd_numbers: '',
                    sack_number: '',
					remarks: '',
                    remarks_show: ''
                }
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getDetail();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.deliverDetail + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        let resData = res.data;
                        this.form = {
							id: resData.id,
							recipient_contacts: resData.recipient_contacts,
							recipient_phone: resData.recipient_phone,
                            odd_numbers: resData.odd_numbers,
							sack_number: resData.sack_number,
							remarks_show: resData.remarks
                        };
                    }
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.remarks === '') {
                    this.$Utils.showTipInfo('請輸入備註');
                    return;
                } 
                this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.shopSignedRemark,
                    method: 'post',
                    data: {
						order_id: this.pageParam.id,
                        remarks: form.remarks,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        this.getDetail();
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                        this.getDetail();
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                    this.getDetail();
                });
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "shopSignedRemark.scss";
</style>